import { Component, OnInit, Input, ViewEncapsulation, ViewChild, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { ControlContainer, NgForm, NgControl, AbstractControl, ValidatorFn, Validators } from '@angular/forms';
import { CommonHelper } from '../../../core/_config/common.helper';
import { CustomValidators } from 'ngx-custom-validators';
import {
  SearchCountryField,
  TooltipLabel,
  CountryISO,
} from 'ngx-intl-tel-input';
// src/app/views/pages/irsip/components/irsip-doctoral-information/services/irsip-doctoral-information-service.service
import { IrsipDoctoralInformationServiceService } from '../../../views/pages/irsip/components/irsip-doctoral-information/services/irsip-doctoral-information-service.service';
import { IrsipForiegnVisitInformationService } from '../../../../app/views/pages/irsip/components/irsip-foriegn-visit-infromation/services/irsip-foriegn-visit-information.service';
@Component({
  selector: 'hec-input',
  templateUrl: './hec-input.component.html',
  styleUrls: ['./hec-input.component.scss'],
  encapsulation: ViewEncapsulation.None,
  viewProviders: [
    {
      provide: ControlContainer, useExisting: NgForm
    },
  ]
})
export class HecInputComponent implements OnInit {

  @ViewChild('input',{static:false}) input: NgControl;
  @Input('') placement: string;
  @Input('') toolsTip: string;
  @Input('') tooltip: string;
  @Input('') toolIcon: boolean = false;
  @Input('') toolText: boolean = false;
  @Input('') displayName: string;
  @Input('') config: any;
  @Input('') name: string
  @Input('') type: string;
  @Input('') options: any;
  @Input('') disabledOptions: any;
  @Input('') value: any;
  @Input('') rows: number;
  @Input('') maxlength: string;
  @Input('') minlength: string;
  @Input('') mode: string;
  @Input('') readonly: boolean = false;
  @Input('') required: boolean = false;
  @Input('') disabled: boolean;
  @Input('') placeholder: string;
  @Input('') min: any;
  @Input('') max: number=5;
  @Input('') hint:string;
  @Input('') pattern: string;
  @Input('') ppattern: string;
  @Input('') numberOptPatternMsg: string;
  @Input('') mindate: Date;
  @Input('') maxdate: Date;
  @Input('') id: any;
  @Input('') patternForDecimal: string;
  @Input('') toolTips:string;
  // My Custom Date Controls
  @Input('') minDate: string = CommonHelper.get100YrOldDateInFormat("YYYY-MM-DD");
  // By Default max date is set to today
  @Input('') maxDate: string = CommonHelper.getDateInFormat("YYYY-MM-DD");
  // My Radio Controls
  @Input('') radioDisplayValue1: string;
  @Input('') radioDisplayValue2: string;
  @Input('') radioValue: boolean;

  @Input('') mustMatch: HecInputComponent;
  @Input('') equalTo: HecInputComponent;
  @Input('') equalToErrorMessage: string;
  @Input('') greaterThan: HecInputComponent;
  @Input('') greaterThanErrorMessage: string;
  @Input('') greaterThanOrEqual: HecInputComponent;
  @Input('') greaterThanOrEqualErrorMessage: string;
  @Input('') lessThan: HecInputComponent;
  @Input('') lessThanErrorMessage: string;
  @Input('') lessThanOrEqual: HecInputComponent;
  @Input('') lessThanOrEqualErrorMessage: string;
  @Input('') disableDate: boolean = false;
  @Input('')searchCtrl:string = ''
  @Output() onBlur = new EventEmitter();
  @Output() selectChanged = new EventEmitter();
  @Output() textChanged = new EventEmitter();
  @Output() dateChanged = new EventEmitter();
  @Output() fieldChanged = new EventEmitter();
  @Output() loadMinDate = new EventEmitter()
  @Output() checkBoxChanged = new EventEmitter();
  @Output() radioButtonChanged = new EventEmitter();
  public MOBILE_REGEX = CommonHelper.MOBILE_REGEX;
  public PHONE_REGEX = CommonHelper.PHONE_REGEX;
  public EMAIL_REGEX = CommonHelper.EMAIL_REGEX;
  public CNIC_REGEX = CommonHelper.CNIC_REGEX;
  public passwordHide = true;
  public num: number = 12345678901
  public SearchCountryField = SearchCountryField;
  public TooltipLabel = TooltipLabel;
  public CountryISO = CountryISO;
  public preferredCountries: CountryISO[] = [CountryISO.Pakistan];
  @Input('') minNumberValue: number = null;
  @Input('') maxNumberValue: number = null;

  constructor(private change: ChangeDetectorRef, 
    private IrsipDoctoralInformationService: IrsipDoctoralInformationServiceService,
    private irsipForiegnVisitInformationService: IrsipForiegnVisitInformationService, ) { }

  ngOnInit() {
    this.setDefaultFieldLengths();

    // Default Number Pattern
    this.pattern = this.pattern || "[0-9]*";

    this.config = {
      displayKey: 'codeValue',
      search: true,
      searchPlaceholder: 'Search',
      placeholder: 'Select One',
      noResultsFound: 'No Matches found!',
      searchOnKey: 'codeValue'
    };

    if (
      (
        this.equalTo
        || this.greaterThan
        || this.greaterThanOrEqual
        || this.lessThan
        || this.lessThanOrEqual) && !this.mode
    ) {
      return;
    }

    if (
      (
        this.equalTo
        || this.greaterThan
        || this.greaterThanOrEqual
        || this.lessThan
        || this.lessThanOrEqual) && this.mode && this.mode.toLowerCase() !== "compare"
    ) {
      return;
    }

    if (
      (
        !this.equalTo
        && !this.greaterThan
        && !this.greaterThanOrEqual
        && !this.lessThan
        && !this.lessThanOrEqual) && this.mode
    ) {
      return;
    }

    if (
      (
        this.greaterThan
        || this.greaterThanOrEqual
        || this.lessThan
        || this.lessThanOrEqual) && (this.type != "number" && this.type != "date" && this.type != "dateOpt")
    ) {
      return;
    }

  }

  compareValues(a: any, b: any): boolean {
    // 1️⃣ Handle null / undefined
    if (a == null && b == null) return true;
    if (a == null || b == null) return false;
  
    // 2️⃣ Handle primitive types (number, string, boolean)
    if (typeof a !== 'object' && typeof b !== 'object') {
      return String(a) === String(b);
    }
  
    // 3️⃣ Handle objects with common identifier keys
    const keysToCheck = ['id', 'value', 'code', 'key', 'uuid'];
    for (const key of keysToCheck) {
      if (a[key] !== undefined && b[key] !== undefined) {
        return a[key] === b[key];
      }
    }
  
    // 4️⃣ Fallback — shallow comparison of all keys (same structure & values)
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
  
    for (const key of aKeys) {
      if (a[key] !== b[key]) return false;
    }
  
    // 5️⃣ Last resort — JSON deep compare (safe but slower)
    try {
      return JSON.stringify(a) === JSON.stringify(b);
    } catch {
      return false;
    }
  }  
  

  setDefaultFieldLengths() {

    if (this.type == "text") {
      this.maxlength = this.maxlength || "50";
    }

    if (this.type == "textarea") {
      this.maxlength = this.maxlength || "500";
    }

    if (this.type == "number" || this.type == "numberOpt") {
      this.maxlength = this.maxlength || "15"
    }

    if (this.type == "decimalNumber" || this.type == "decimalNumberOpt") {
      this.maxlength = this.maxlength || "15"
    }

    if (this.type == "email" || this.type == "emailOpt") {
      this.maxlength = this.maxlength || "50"
    }

    if (this.type == "cell" || this.type == "cellOpt") {
      this.maxlength = this.maxlength || "11"
    }

    if (this.type == "phone" || this.type == "phoneOpt") {
      this.maxlength = this.maxlength || "11"
    }

  }

  ngAfterViewInit() {
    if (this.mode && this.mode.toLowerCase() == "compare" && this.equalTo) {
      this.input.control.setValidators([CustomValidators.equalTo(this.equalTo.input.control)]);
    }
    if (this.type && (this.type == "date" || this.type == "dateOpt" || this.type == "ngbDate")) {
      if (this.mode && this.mode.toLowerCase() == "compare" && this.greaterThanOrEqual) {
        this.input.control.setValidators([CustomValidators.minDate(this.greaterThanOrEqual.input.control)]);
      }
      if (this.mode && this.mode.toLowerCase() == "compare" && this.lessThanOrEqual) {
        this.input.control.setValidators([CustomValidators.maxDate(this.lessThanOrEqual.input.control)]);
      }
    }
    this.change.detectChanges();
  }


  blur(event: FocusEvent) {
    this.onBlur.emit();
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\ ]/;

    if (!pattern.test(event.key)) {
      event.preventDefault();
    }
  }

  selectEvent(event) {
    this.selectChanged.emit(event.value);
    console.log("Field Type: ",event.source.ngControl.name);
    if(event.source.ngControl.name == 'phdFieldOfStudy'){
      this.IrsipDoctoralInformationService.triggerPhdFieldOfStudyChange(event.value);
    }
    else if(event.source.ngControl.name == 'foreignVisitCountryId'){
      this.irsipForiegnVisitInformationService.triggerForeignVisitCountrySelectChange(event.value);
    }
    // else if(event.source.ngControl.name == 'irsipCountryId'){
    //   this.IrsipDoctoralInformationService.triggerIrsipCountrySelectChange(event.value);
    // }
  }

//   textChangedEvent(event) {
//     this.textChanged.emit(event);
//   }

  fieldValue(event) {
    if (event.key == 'e')
      event.preventDefault();
  }

  dateChangedEvent(event) {
    this.dateChanged.emit(event.target.value)
  }

  radioChangedEvent(event){
    this.radioButtonChanged.emit(event)
  }

  checkBoxEvent(event){
    this.checkBoxChanged.emit(event.target.checked)
  }

  dateNgModelChangedEvent(event) {
    let userSelectedDate = new Date(event);
    let maxDate = new Date(this.maxDate) || null;
    let minDate = new Date(this.minDate) || null;
    if (String(minDate) == String(userSelectedDate)) {
      this.greaterThanOrEqualErrorMessage = 'End date should be greater than Start date'
      this.input.control.setErrors({ minDate: true })
      return;
    } else if (minDate != userSelectedDate) {
      this.input.control.setErrors(null);
    }
    this.dateChanged.emit(event);

  }

  textChangedEvent(event) {
    this.textChanged.emit(event);
    if (this.type && this.type == 'number') {
      if (this.minNumberValue && this.maxNumberValue) {
        // this.input.control.setValidators([this.range(this.minNumberValue,this.maxNumberValue)]);
        // this.change.detectChanges()
        if (
          event &&
          !(+event >= +this.minNumberValue && +event <= +this.maxNumberValue)
        ) {
          this.input.control.setValidators([
            this.range(this.minNumberValue, this.maxNumberValue),
          ]);
          this.input.control.updateValueAndValidity();
          this.change.detectChanges();
        } else {
          this.input.control.clearValidators();
          this.input.control.setValidators(Validators.required);
          this.input.control.updateValueAndValidity();
          this.change.detectChanges();
        }
        this.change.detectChanges();
      }else if(this.minNumberValue && !this.maxNumberValue){
        console.log('res',+event < +this.minNumberValue)
        if (
          event &&
          (+event < +this.minNumberValue)
        ){
          console.log(event)
          console.log(this.minNumberValue)
          this.input.control.setValidators([
            this.minValue(this.minNumberValue),
          ]);
          // this.input.control.setErrors({ minValue: true });
          // console.log(this.input)
          this.input.control.updateValueAndValidity();
          this.change.detectChanges();
        } else {
          this.input.control.clearValidators();
          this.input.control.setValidators(Validators.required);
          this.input.control.updateValueAndValidity();
          this.change.detectChanges();
        }

      }
    }
  }

  changeInput(event) {
    if (this.type == 'number') {
      if (this.minNumberValue && this.maxNumberValue) {
        if (
          event &&
          !(+event >= +this.minNumberValue && +event <= +this.maxNumberValue)
        ) {
          this.input.control.setErrors({ outOfRange: true });
        } else {
          this.input.control.setErrors({ outOfRange: null });
          this.input.control.updateValueAndValidity();
        }
        this.change.detectChanges();
      }
    }
  }

  private minValue(min: number): ValidatorFn {
    return (c: AbstractControl): { [key: string]: boolean } | null => {
      let value = +c.value;
      if (
        value != undefined &&
        value != null &&
        (isNaN(value) || value <= min)
      ) {
        return { minValue: true };
      }
      return null;
    };
  }

  private range(min: number, max: number): ValidatorFn {
    return (c: AbstractControl): { [key: string]: boolean } | null => {
      let value = +c.value;
      if (
        value != undefined &&
        value != null &&
        (isNaN(value) || value <= min || value >= max)
      ) {
        return { outOfRange: true };
      }
      return null;
    };
  }

}
